import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import { Badge } from "react-bootstrap";
import { toast } from 'react-toastify';
import { logincheck } from '../Userlogin/Userlogin'

class CompliantList extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {
      tabs: ["", "", ""],
      tabPanel: ["", "", ""],
      tabPanel0: "",
      tabPanel1: "",
      tabPanel2: "",
      modal: false,
      compliantData: []
    };
    // this.submitHandler = this.submitHandler.bind(this);
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  componentDidMount() {
	  
	logincheck(this.props.userId, this.props.mobiledevice).then(({ data: data }) => {
		console.log(data.status_check)
		if(data.status_check === 0) {
			this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
		}
	})
	if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User"  || this.props.userRole =='CRE') {
		const url = process.env.REACT_APP_NODE_ENV + "/api/compliant/compliantlist";
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          return response.json();
        }
      ).then(data => {
		  console.log(data)
        this.setState({ compliantData: data.data })
      })
	}
	else if (this.props.userRole === "Corporate Customer" ) {
		   let userdetails = { user_id : this.props.userId }
	   
    fetch(process.env.REACT_APP_NODE_ENV + '/api/customer/get_profile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(userdetails)
    }).then((response) => response.json())
      .then(data => {
		  
		  if(data.length != 0) {
			
		}
		else {
			if(this.props.userRole === 'Individual Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/indiv-customer/customer-create-user", data: "" });
			}
			else if(this.props.userRole === 'Apartment Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/indiv-customer/customer-create-user", data: "" });
				
			}
			else if(this.props.userRole === 'Corporate Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/corp-customer/customer-create-user", data: "" });
				
			}
		}
		  
		  
	  })
	  
	        	const postCustData =
				{
					user_id: this.props.userId,
				};
				fetch(process.env.REACT_APP_NODE_ENV + '/api/compliant/userbasedcompliantlist', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
					},
					body: JSON.stringify(postCustData)
				}).then((res) => res.json())
					.then((data1) => {
						console.log(data1.data,'sjfdsjdhj')
						this.setState({ compliantData: data1.data })
				}).catch((err) => console.log(err))	
		 
				
	
		
		
		
	}
	else if(this.props.userRole === "Apartment Customer") {
		   let userdetails = { user_id : this.props.userId }
	   
    fetch(process.env.REACT_APP_NODE_ENV + '/api/customer/get_profile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(userdetails)
    }).then((response) => response.json())
      .then(data => {
		  
		  if(data.length != 0) {
			
		}
		else {
			if(this.props.userRole === 'Individual Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/indiv-customer/customer-create-user", data: "" });
			}
			else if(this.props.userRole === 'Apartment Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/aprt-customer/customer-user-create", data: "" });
				
			}
			else if(this.props.userRole === 'Corporate Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/corp-customer/customer-create-user", data: "" });
				
			}
		}
		  
		  
	  })
		
				const postCustData =
				{
					user_id: this.props.userId,
				};
				fetch(process.env.REACT_APP_NODE_ENV + '/api/compliant/userbasedcompliantlist', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
					},
					body: JSON.stringify(postCustData)
				}).then((res) => res.json())
				
							
	
					.then((data) => {
						//console.log(data1.data,'sjfdsjdhj')
						this.setState({ compliantData: data.data })
				}).catch((err) => console.log(err))
		 

	}
	else if(this.props.userRole === "Individual Customer") {
		
		     let userdetails = { user_id : this.props.userId }
	   
    fetch(process.env.REACT_APP_NODE_ENV + '/api/customer/get_profile', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      },
      body: JSON.stringify(userdetails)
    }).then((response) => response.json())
      .then(data => {
		  
		  if(data.length != 0) {
			
		}
		else {
			if(this.props.userRole === 'Individual Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/indiv-customer/customer-create-user", data: "" });
			}
			else if(this.props.userRole === 'Apartment Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/aprt-customer/customer-user-create", data: "" });
				
			}
			else if(this.props.userRole === 'Corporate Customer') {
				toast.dismiss()
				toast.error("Please complete your profile to proceed", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000
				});
				this.props.history.push({ pathname: "/corp-customer/customer-create-user", data: "" });
				
			}
		}
		  
		  
	  })
		
		
				const postCustData =
				{
					user_id: this.props.userId,
				};
				fetch(process.env.REACT_APP_NODE_ENV + '/api/compliant/userbasedcompliantlist', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
					},
					body: JSON.stringify(postCustData)
				}).then((res) => res.json())
					.then((data) => {
						//console.log(data1.data,'sjfdsjdhj')
						this.setState({ compliantData: data.data })
				}).catch((err) => console.log(err))
		 

	}
	
	
  }


  render() {

    let dataArr = [];
	if(this.state.compliantData){
		this.state.compliantData.map((data) => {
			let variant = "";
			let statusdata = "";
			let notedata = "";
			if(data.ticket_status === "Pending"){
				variant = "danger";  statusdata = "Pending" 
			}else if(data.ticket_status === "In Progress"){
				variant = "info";  statusdata = "In Progress" 
			}else {
				variant = "success" ; statusdata = "Closed" 
			}
			if(data.note.length > 49){
				notedata = data.note.substring(0,50)+'...'
			}else{
				notedata = data.note
			}
		  let mdData = [
			 data.ticket_id, data.user_id, data.parent_category, notedata, data.ticket_status, data
		  ];
		  dataArr.push(mdData)
		  return null;
		});
	}
	
	const mystyle = {
	  marginRight: "5px"
    };

    const columns = [
		
      {
        name: "ticket_id",
        label: "Ticket Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "user_id",
        label: "User Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "parent_category",
        label: "Parent Category",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "note",
        label: "Note",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "ticket_status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
			  console.log(value.id)
            return (
              <>
				<Button variant="outline-success" onClick={() => this.nextPath("/register-compliant/edit-compliant", value.id)} style={mystyle}> Edit </Button>
              </>
            );
          }
        }
      }
    ];

	const columns1 = [				
      {
        name: "ticket_id",
        label: "Ticket Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "user_id",
        label: "User Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "parent_category",
        label: "Parent Category",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "note",
        label: "Note",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "ticket_status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
			  console.log(value.id)
            return (
              <>
				<Button variant="outline-success" onClick={() => this.nextPath("/register-compliant/view-compliant-user", value.id)} style={mystyle}> View  </Button>
              </>
            );
          }
        }
      }
    ];

    const options = {
      ffilterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false,
      downloadOptions: {
        filename: 'compliant_list.csv',
      }
    };
	
	let showTableColumn = "";
	let showTableData = "";
	let showOption = "";
    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User"  || this.props.userRole =='CRE') {
      showTableColumn = columns;
      showTableData = dataArr;
      showOption = options;
    } else {
      showTableColumn = columns1;
      showTableData = dataArr;
      showOption = options;
    }

    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User"  || this.props.userRole =='CRE') {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>Register Compliant</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: "10px" }}>
            <Button className="float-right"
              variant="outline-success"
              style={{ marginTop: "10px", marginRight: "10px", width: "200px" }}
              onClick={() => this.nextPath("/register-compliant/create-compliant", "")
              }>
              Create Compliant
                    </Button>
            <MUIDataTable
              title={"Compliant List"}
              data={dataArr}
              columns={showTableColumn}
              options={options} />

          </div>
        </>
      );
    } else {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item active>My Compliants</Breadcrumb.Item>
          </Breadcrumb>

          <div style={{ marginTop: "10px" }}>
            <Button className="float-right"
              variant="outline-success"
              style={{ marginTop: "10px", marginRight: "10px", width: "200px" }}
              onClick={() => this.nextPath("/register-compliant/create-compliant-user", "")
              }>
              Create Compliant
                    </Button>
            <MUIDataTable
              title={"Compliant List"}
              data={dataArr}
              columns={columns1}
              options={options} />

          </div>
        </>
     );
    }

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id,
	mobiledevice: state.auth.user[0].mobiledeviceId,
  }
}

export default connect(
  mapStateToProps,
  null
)(CompliantList)
